export default __webpack_public_path__ + "static/media/pin.19a7e1d1.svg";